import * as React from 'react';
import './PersonnelPage.scss';
import { History, Location } from "history";
import { connect } from "react-redux";
import { match } from "react-router";
import { routerActions } from 'react-router-redux';
import { bindActionCreators } from "redux";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { CheckboxFormInput, DatePickerFormInputFabric, SelectFormInput, TextFormInput } from "../../../components/form/index";
import { RestrictedLayout } from "../../../components/layouts/index";
import { renderRegistrationFormSaveBlock, renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning } from "../../../helpers/alert";
import { RegistrationComponent, renderFormControls } from "../../../helpers/formHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { IPersonnelReduxFormState, initialPersonnelState } from "../../../reducers/reactReduxForms/personnel";
import * as PersonnelActions from '../../../actions/personnel';
import { NotificationAlert } from "../../../components/common/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import * as Dtos from '../../../dtos/Tmd.dtos';
import { RequestState } from "../../../enumerations/RequestState";
import { findLookup, generateOptionsFromLookup, generateSuggestionsFromLookup } from "../../../helpers/lookupHelper";
import { ITmdState } from "../../../reducers/index";
import { Form, actions } from 'react-redux-form';
import { TextAreaFormInput } from '../../../components/form';
import * as AuthenticationHelper from '../../../helpers/authentication';
import { PersonnelSubMenu } from '../../../helpers/subMenuHelper';
import * as FormHelper from '../../../helpers/formHelper';
import SuggestionFormInput from 'src/components/form/inputs/SuggestionFormInput/SuggestionFormInput';
import { GridRemove } from 'src/enumerations/GridRemove';
import * as ReactTooltip from 'react-tooltip';
interface IPersonnelPageParams {
  personnelId: number;
}
interface IPersonnelPageProps {
  form: Dtos.Personnel & IRegistrationFormState;
  formState: Dtos.FormState;
  formProperties: Dtos.FormProperty[];
  reduxFormState: IPersonnelReduxFormState;
  location: Location;
  personnelId: number;
  match: match<IPersonnelPageParams>;
  history: History;

  // From state
  personnel: Dtos.Personnel;
  lookups: Dtos.Lookup[];
  loadingPersonnel: boolean;
  loadPersonnelSuccess: boolean;
  loadPersonnelFailure: boolean;
  savingPersonnel: boolean;
  savePersonneluccess: boolean;
  savePersonnelFailure: boolean;
  creatingPersonnel: boolean;
  createPersonnelSuccess: boolean;
  createPersonnelFailure: boolean;
  validationFailures: Dtos.ResponseError[];
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
  formRoles: Dtos.RoleType[];
}
interface IPersonnelPageActions {
  clearPersonnel: PersonnelActions.IPersonnelClearActionCreator;
  loadPersonnel: PersonnelActions.IPersonnelLoadByIdActionCreator;
  savePersonnel: PersonnelActions.IPersonnelaveActionCreator;
  createPersonnel: PersonnelActions.IPersonnelCreateActionCreator;
  loadForm: typeof actions.load;
  changeForm: typeof actions.change;
  resetForm: typeof actions.reset;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
}
type PersonnelPageProps = IPersonnelPageProps & IPersonnelPageActions;

// const formName: string = "personnel";
const reduxFormName: string = "reduxForms.personnel";
// const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex"
// const tableStyleClass: React.CSSProperties = {
//     textAlign: "left",
//     fontWeight: "bold",
//     color: "white",
//     cursor: "pointer"
// }

class PersonnelPage extends React.PureComponent<PersonnelPageProps, any> {
  constructor(props: PersonnelPageProps) {
    super(props);
    this.state = {
      showUsernameWarning: false
    };
    this.clearPersonnel = this.clearPersonnel.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.loadForm = this.loadForm.bind(this);
    this.changeShowUsernameWarning = this.changeShowUsernameWarning.bind(this);
  }
  componentDidMount() {
    const {
      loadPersonnel,
      personnelId,
      createPersonnel
    } = this.props;
    if (personnelId) {
      loadPersonnel(personnelId);
    } else if (!personnelId) {
      createPersonnel();
    }

    // if (lookups) {
    //     this.setState({ companyNameOptions: generateSuggestionsFromLookup(findLookup("Personnel", "CompanyName", lookups) , form.companyName)})
    // }
  }
  componentWillReceiveProps(_nextProps: PersonnelPageProps) {}
  componentDidUpdate(prevProps: PersonnelPageProps, _prevState) {
    const {
      personnel,
      personnelId,
      form,
      navigate,
      loadPersonnel,
      loadingPersonnel,
      loadPersonnelSuccess,
      createPersonnel,
      creatingPersonnel,
      createPersonnelSuccess: createPersonneluccess,
      savingPersonnel,
      savePersonneluccess: savePersonnelSuccess,
      validationFailures
    } = this.props;
    if (personnelId && prevProps.personnelId != personnelId) {
      loadPersonnel(personnelId);
      if (this.state.showUsernameWarning) {
        this.setState({
          showUsernameWarning: false
        });
      }
    } else if (!personnelId && prevProps.personnelId) {
      createPersonnel();
      if (this.state.showUsernameWarning) {
        this.setState({
          showUsernameWarning: false
        });
      }
    }
    if (!loadingPersonnel && prevProps.loadingPersonnel) {
      if (loadPersonnelSuccess) {
        this.loadForm();
      } else {}
    }

    // if (lookups && lookups !== prevProps.lookups) {
    //     this.setState({ companyNameOptions: generateSuggestionsFromLookup(findLookup("Personnel", "CompanyName", lookups) , form.companyName)})
    // }

    if (!savingPersonnel && prevProps.savingPersonnel) {
      if (savePersonnelSuccess) {
        if (validationFailures && validationFailures.length > 0) {
          Alert.warning(<NotificationAlert alertContent={renderRegistrationFormSaveWarning(validationFailures)} icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE} />);

          // toggleMessageModal();
        } else {
          Alert.success(<NotificationAlert alertContent={renderRegistrationFormSaveSuccess()} icon={FontAwesomeIcons.Solid.CHECK} />);
        }
        if (form.saveAndReturn) {
          navigate("/personnel");
        } else if (!form.saveAndReturn && personnelId && personnelId > 0) {
          this.loadForm();
        } else if (!form.saveAndReturn && !personnelId && personnel && personnel.id > 0) {
          navigate("/personnel/" + personnel.id + "/details");
        }
      } else {
        Alert.error(<NotificationAlert alertContent={this.renderErrorAlert()} icon={FontAwesomeIcons.Solid.TIMES_OCTAGON} />);
      }
    }
    if (!creatingPersonnel && prevProps.creatingPersonnel) {
      if (createPersonneluccess) {
        this.loadForm();
      } else {}
    }
  }
  componentWillUpdate(_nextProps: PersonnelPageProps) {}
  componentWillUnmount() {
    const {
      resetForm,
      loadForm
    } = this.props;
    this.clearPersonnel();
    loadForm(reduxFormName, initialPersonnelState);
    resetForm(reduxFormName);
  }
  changeShowUsernameWarning(value: boolean) {
    this.setState({
      showUsernameWarning: value
    });
  }
  clearPersonnel() {
    this.props.clearPersonnel();
  }
  showPersonnel(): boolean {
    const {
      loadingPersonnel,
      loadPersonnelSuccess
    } = this.props;
    if (!loadingPersonnel && loadPersonnelSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingPersonnel,
      personnelId,
      personnel,
      permissions
    } = this.props;
    return <RestrictedLayout permission={Dtos.Permission.PersonnelView} subMenuTitle={personnel ? personnel.display : ""} subMenuItems={personnelId == undefined ? undefined : PersonnelSubMenu(personnelId, permissions)} loading={loadingPersonnel} data-sentry-element="RestrictedLayout" data-sentry-component="PersonnelPage" data-sentry-source-file="PersonnelPage.tsx">

            {this.renderContent()}
        </RestrictedLayout>;
  }
  renderContent() {
    const {
      form,
      lookups,
      validationFailures,
      formProperties,
      formState,
      changeForm,
      savingPersonnel,
      permissions
    } = this.props;
    let self = this;
    const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.PersonnelUpdate, Dtos.Permission.PersonnelCreate);
    const formDisabledOnEdit: boolean = !hasPermission || FormHelper.isEdit(formState, form);
    const formDisabled: boolean = !hasPermission || savingPersonnel || formState && formState.formStatus == Dtos.FormStatus.Disabled;
    let activeDirectoryError: string = "";
    if (validationFailures) {
      validationFailures.forEach(validationFailure => {
        if (validationFailure.errorCode === "AD-099") {
          activeDirectoryError = validationFailure.message;
        }
      });
    }
    const activeDirectoryLock: boolean = formDisabledOnEdit && form !== undefined && form.activeDirectoryUser !== undefined && form.activeDirectoryUser !== null && form.activeDirectoryUser !== "";
    let formComponents: {
      [index: string]: RegistrationFormComponent;
    } = {
      detailsGroup: {
        type: RegistrationComponent.RegistrationGroupFormControls,
        components: {
          salutationId: {
            type: RegistrationComponent.RegistrationControl,
            inputType: SelectFormInput,
            inputDisabled: formDisabled,
            inputProps: {
              options: generateOptionsFromLookup(findLookup("Personnel", "SalutationId", lookups), form.salutationId)
            },
            changeAction: (model, value, form, parentModel) => {
              changeForm(model, value);
              changeForm(reduxFormName + ".salutation", null);
            },
            size: 2
          },
          salutationSpacer: {
            type: RegistrationComponent.RegistrationElement,
            size: 2,
            component: <></>
          },
          firstName: {
            type: RegistrationComponent.RegistrationControl,
            inputType: TextFormInput,
            inputDisabled: formDisabled,
            size: 2,
            blurAction: (form, parentModel) => {
              if (form.firstName && form.firstName != '' && form.lastName && form.lastName != '' && (!form.userName || form.userName == '')) {
                changeForm("reduxForms.personnel.userName", (form.firstName[0] + "." + form.lastName).toLowerCase().trim());
                self.changeShowUsernameWarning(true);
              }
            }
          },
          lastName: {
            type: RegistrationComponent.RegistrationControl,
            inputType: TextFormInput,
            inputDisabled: formDisabled,
            size: 2,
            blurAction: (form, parentModel) => {
              if (form.firstName && form.firstName != '' && form.lastName && form.lastName != '' && (!form.userName || form.userName == '')) {
                changeForm("reduxForms.personnel.userName", (form.firstName[0] + "." + form.lastName).toLowerCase().trim());
                self.changeShowUsernameWarning(true);
              }
            }
          },
          genderId: {
            type: RegistrationComponent.RegistrationControl,
            inputType: SelectFormInput,
            inputDisabled: formDisabled,
            inputProps: {
              options: generateOptionsFromLookup(findLookup("Personnel", "GenderId", lookups), form.genderId)
            },
            size: 2
          }
        }
      },
      professionalDetails: {
        type: RegistrationComponent.RegistrationGroupFormControls,
        components: {
          heading: {
            type: RegistrationComponent.RegistrationElement,
            size: 1,
            component: <h3 className="mt-3">Contact Details</h3>
          },
          residentialPostcode: {
            type: RegistrationComponent.RegistrationControl,
            inputType: TextFormInput,
            inputDisabled: formDisabled,
            size: 2
          },
          professionalDetails: {
            type: RegistrationComponent.RegistrationGrid,
            formName: "PersonnelProfessionalDetails",
            disabled: formDisabled,
            className: "source-documents-source-documents",
            minRows: 0,
            initialState: undefined,
            columnStyles: [{
              width: undefined,
              minWidth: "200px"
            }, {
              width: "125px"
            }],
            removeConfig: GridRemove.All,
            addRow: (_gridComponent, _index, _array) => {
              const state: Dtos.PersonnelProfessionalDetails = Object.assign({});
              return state;
            },
            components: (rowIndex: number) => ({
              "Contact Details (Institution)": {
                type: RegistrationComponent.RegistrationGroupFormControls,
                groupClassName: "grid-group",
                components: {
                  "Contact Details": {
                    type: RegistrationComponent.RegistrationGroupFormControls,
                    components: {
                      primaryEmail: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 2,
                        inputProps: {
                          addOnRight: <div style={{
                            margin: '-1px -8px'
                          }} data-tip={`The email address for the institution selected below.`}>  
                                                        <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_CIRCLE} fixedWidth />
                                                        <ReactTooltip />
                                                    </div>
                        }
                      },
                      secondaryEmail: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 2
                      },
                      phone: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 2
                      },
                      mobile: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 2
                      }
                    }
                  },
                  "Institution Details": {
                    type: RegistrationComponent.RegistrationGroupFormControls,
                    components: {
                      primaryDetails: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: CheckboxFormInput,
                        inputDisabled: formDisabled,
                        size: 1,
                        inputProps: {
                          label: "Primary Institution"
                        },
                        inputLabel: " ",
                        labelClassName: "col-form-label col-sm-3",
                        fieldClassName: "col-sm-9 generic-form-field"
                      },
                      institutionId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputProps: {
                          options: generateOptionsFromLookup(findLookup("PersonnelProfessionalDetails", "institutionId", lookups))
                        },
                        inputDisabled: formDisabled,
                        size: 2
                      },
                      institutionOther: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled || form && !form.professionalDetails || form && form.professionalDetails && !form.professionalDetails[rowIndex] || form && form.professionalDetails && form.professionalDetails[rowIndex] && form.professionalDetails[rowIndex].institutionId !== -1,
                        size: 2
                      },
                      department: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 2
                      },
                      jobTitle: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 1
                      }
                    }
                  },
                  "Address Details": {
                    type: RegistrationComponent.RegistrationGroupFormControls,
                    components: {
                      addressLine1: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 1
                      },
                      addressLine2: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 1
                      },
                      citySuburb: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 2
                      },
                      postcode: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 2
                      },
                      stateProvinceRegionId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: formDisabled,
                        inputProps: {
                          options: generateOptionsFromLookup(findLookup("PersonnelProfessionalDetails", "StateProvinceRegionId", lookups))
                        },
                        size: 2
                      },
                      stateOther: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled || form && !form.professionalDetails || form && form.professionalDetails && !form.professionalDetails[rowIndex] || form && form.professionalDetails && form.professionalDetails[rowIndex] && form.professionalDetails[rowIndex].stateProvinceRegionId !== 10,
                        size: 2
                      },
                      countryId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: formDisabled,
                        inputProps: {
                          options: generateOptionsFromLookup(findLookup("PersonnelProfessionalDetails", "CountryId", lookups))
                        },
                        size: 2
                      }
                    }
                  }
                }
              }
            })
          }
        }
      },
      professionalGroup: {
        type: RegistrationComponent.RegistrationGroupFormControls,
        components: {
          heading: {
            type: RegistrationComponent.RegistrationElement,
            size: 1,
            component: <h3 className="mt-3">Professional Details</h3>
          },
          cvDate: {
            type: RegistrationComponent.RegistrationControl,
            inputType: DatePickerFormInputFabric,
            validationMessageAbove: true,
            inputDisabled: formDisabled,
            size: 2
          },
          professionalDisciplineId: {
            type: RegistrationComponent.RegistrationControl,
            inputType: SelectFormInput,
            inputDisabled: formDisabled,
            inputProps: {
              options: generateOptionsFromLookup(findLookup("Personnel", "ProfessionalDisciplineId", lookups), form.professionalDisciplineId)
            },
            size: 2
          },
          otherDisciplines: {
            type: RegistrationComponent.RegistrationControl,
            inputType: TextFormInput,
            inputDisabled: formDisabled || form && form.professionalDisciplineId == null || form && form.professionalDisciplineId != 15,
            size: 1
          },
          personnelInterests: {
            type: RegistrationComponent.RegistrationControl,
            inputType: SelectFormInput,
            inputDisabled: formDisabled,
            inputProps: {
              multi: true,
              value: form.personnelInterests ? form.personnelInterests.filter(f => f.active).map(val => val.interestId) : [],
              options: generateOptionsFromLookup(findLookup("Personnel", "PersonnelInterests", lookups))
            },
            changeAction: (model, value, form, parentModel) => {
              changeForm(model, value.map(v => {
                return {
                  active: 1,
                  interestId: v
                };
              }));
            },
            size: 1
          },
          otherInterests: {
            type: RegistrationComponent.RegistrationControl,
            inputType: TextFormInput,
            inputDisabled: formDisabled,
            size: 1
          }
        }
      },
      membershipDetails: {
        type: RegistrationComponent.RegistrationGroupFormControls,
        components: {
          heading: {
            type: RegistrationComponent.RegistrationElement,
            size: 1,
            component: <h3 className="mt-3">TROG Membership Details</h3>
          },
          membershipTypeId: {
            type: RegistrationComponent.RegistrationControl,
            inputType: SelectFormInput,
            inputDisabled: formDisabled,
            inputProps: {
              options: generateOptionsFromLookup(findLookup("Personnel", "MembershipTypeId", lookups), form.membershipTypeId)
            },
            size: 2
          },
          membershipExpiryDate: {
            type: RegistrationComponent.RegistrationControl,
            inputType: DatePickerFormInputFabric,
            validationMessageAbove: true,
            inputDisabled: formDisabled,
            size: 2
          },
          userName: {
            type: RegistrationComponent.RegistrationControl,
            inputType: TextFormInput,
            inputDisabled: formDisabled || activeDirectoryLock,
            size: 2,
            changeAction: (model, value, form, parentModel) => {
              changeForm(model, value);
              self.changeShowUsernameWarning(false);
            }
          },
          activeDirectoryError: {
            type: RegistrationComponent.RegistrationElement,
            size: 1,
            hide: !activeDirectoryError,
            component: <div className="col-md-12 mt-2">
                            <div className="alert alert-danger d-flex">
                                <div className="mr-2">
                                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.EXCLAMATION_TRIANGLE} fixedWidth />
                                </div>
                                <span>{activeDirectoryError}</span>
                            </div>
                        </div>
          },
          showUsernameWarning: {
            type: RegistrationComponent.RegistrationElement,
            size: 1,
            hide: !this.state.showUsernameWarning,
            component: <div className="col-md-12 mt-2">
                            <div className="alert alert-info d-flex">
                                <div className="mr-2">
                                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                                </div>
                                <span>Username was auto-generated based on the first and last name, if the username generated is attached to another personnel, please amend until a unique username is achieved.</span>
                            </div>
                        </div>
          }
        }
      },
      comments: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextAreaFormInput,
        inputDisabled: formDisabled,
        labelClassName: "col-form-label col-sm-3",
        fieldClassName: "col-sm-9 generic-form-field"
      },
      active: {
        type: RegistrationComponent.RegistrationControl,
        inputType: CheckboxFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          label: "Active"
        },
        inputLabel: " ",
        labelClassName: "col-form-label col-sm-3",
        fieldClassName: "col-sm-9 generic-form-field"
      }
    };
    return <div>
                <h1>Personnel</h1>
                <Form model={reduxFormName} onSubmit={(val, _event) => this.handleOnSubmit(val)} onSubmitFailed={val => this.handleOnSubmitFailed(val)}>
                    {renderFormControls(form, "personnel", formComponents, lookups, validationFailures, formProperties, changeForm)}
                    <div className="mt-4 mb-4 text-right">
                        <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", false);
          }} type="submit" className="btn btn-primary mr-2">
                            Submit
                        </button>

                        <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
          }} type="submit" className="btn btn-primary mr-2">
                            Submit And Return
                        </button>
                        <button onClick={this.onCancel} className="btn btn-primary mr-2"> Cancel </button>
                    </div>
                </Form>

            </div>;
  }
  renderErrorAlert(): any {
    return <div>
            The form was <strong> not </strong> saved.
        </div>;
  }
  renderWarningAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>;
  }
  renderSaveSuccessAlert(): any {
    return <div>The form has been saved successfully</div>;
  }
  handleOnSubmit(data: Dtos.Personnel) {
    const {
      savePersonnel
    } = this.props;
    if (data) {
      let changes: Dtos.Personnel = ({} as Dtos.Personnel);
      savePersonnel(Object.assign({
        ...data
      }, changes));
    }
  }
  handleOnSubmitFailed(data: Dtos.Personnel) {
    Alert.error(<NotificationAlert minWidth={500} alertContent={renderRegistrationFormSaveBlock()} icon={FontAwesomeIcons.Solid.BAN} />);
  }
  onCancel() {
    const {
      navigate
    } = this.props;
    navigate("/personnel");
  }
  loadForm() {
    const {
      loadForm,
      personnel
    } = this.props;
    let extraData: Dtos.Personnel = ({} as Dtos.Personnel);
    if (personnel) {
      const personnelToLoad = {
        ...personnel
      };
      if (!personnelToLoad.professionalDetails || personnelToLoad.professionalDetails.length === 0) {
        personnelToLoad.professionalDetails = initialPersonnelState.professionalDetails;
      }
      loadForm(reduxFormName, Object.assign({
        ...personnelToLoad
      }, extraData));
    } else {
      loadForm(reduxFormName, Object.assign({
        ...initialPersonnelState
      }, extraData));
    }
  }
}
const mapStateToProps = (state: ITmdState, ownProps: PersonnelPageProps): IPersonnelPageProps => {
  let personnel: Dtos.Personnel | undefined = !(state.personnel.formData instanceof Array) ? state.personnel.formData : undefined;
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    match: ownProps.match,
    personnelId: ownProps.match && ownProps.match.params.personnelId && ownProps.match.params.personnelId.toString() != "create" ? ownProps.match.params.personnelId : undefined!,
    history: ownProps.history,
    location: state.routing.location,
    personnel: personnel!,
    loadingPersonnel: state.personnel.loadState && state.personnel.loadState.status == RequestState.Pending,
    loadPersonnelSuccess: state.personnel.loadState && state.personnel.loadState.status == RequestState.Success,
    loadPersonnelFailure: state.personnel.loadState && state.personnel.loadState.status == RequestState.Failure,
    savingPersonnel: state.personnel.saveState && state.personnel.saveState.status == RequestState.Pending,
    savePersonneluccess: state.personnel.saveState && state.personnel.saveState.status == RequestState.Success,
    savePersonnelFailure: state.personnel.saveState && state.personnel.saveState.status == RequestState.Failure,
    creatingPersonnel: state.personnel.createState && state.personnel.createState.status == RequestState.Pending,
    createPersonnelSuccess: state.personnel.createState && state.personnel.createState.status == RequestState.Success,
    createPersonnelFailure: state.personnel.createState && state.personnel.createState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    formRoles: state.user.formRoles,
    lookups: state.personnel.lookups,
    form: state.reduxForms.personnel,
    formState: state.personnel.formState,
    formProperties: state.personnel.formProperties,
    reduxFormState: state.reduxForms.formState.personnel,
    validationFailures: personnel ? state.personnel.validationFailures : undefined
  };
};
const mapDispatchToProps = (dispatch): IPersonnelPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadForm: bindActionCreators(actions.load, dispatch),
    changeForm: bindActionCreators(actions.change, dispatch),
    resetForm: bindActionCreators(actions.reset, dispatch),
    loadPersonnel: bindActionCreators(PersonnelActions.LoadPersonnelById, dispatch),
    clearPersonnel: bindActionCreators(PersonnelActions.Clear, dispatch),
    savePersonnel: bindActionCreators(PersonnelActions.SavePersonnel, dispatch),
    createPersonnel: bindActionCreators(PersonnelActions.CreatePersonnel, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PersonnelPage);